import { UseFormReturn } from 'react-hook-form';
import { useIntl } from 'react-intl';

import {
    MembershipFormSchemaValues
} from 'src/features/membership/formSchema';
import { membershipMessages } from 'src/features/membership/utils/messages.tsx';
import InputFormField from 'src/registry/components/forms/InputFormField';
import CalendarWithTime from 'src/registry/components/inputs/CalendarWithTime';
import { Form, FormControl, FormControlStack, FormField, FormItem, FormLabel, FormMessage } from 'src/registry/ui/Form';
import { Select, SelectTrigger } from 'src/registry/ui/Select';
import { generalMessages } from 'src/registry/utils/messages';
import { Separator } from 'src/registry/ui/Separator';
import EntityFormField from 'src/features/membership/components/forms/EntityFormField';

type MembershipFormProps = {
    form: UseFormReturn<MembershipFormSchemaValues>;
    onSubmit: (values: MembershipFormSchemaValues) => void;
    membershipTypeName: string;
};
function MembershipForm({ onSubmit, form, membershipTypeName }: MembershipFormProps) {
    const { formatMessage } = useIntl();

    return (
        <Form form={form} onSubmit={form.handleSubmit(onSubmit)} variant="dialog">
            <FormItem variant="dialog">
                <FormLabel variant="dialog" required>
                    {formatMessage(membershipMessages.template)}
                </FormLabel>
                <FormControl>
                    <Select disabled>
                        <SelectTrigger className="w-full">{membershipTypeName}</SelectTrigger>
                    </Select>
                </FormControl>
            </FormItem>
            <InputFormField<MembershipFormSchemaValues>
                form={form}
                name="name"
                label={formatMessage(generalMessages.name)}
            />
            <Separator />
            <EntityFormField form={form} />
            <Separator />
            <FormField
                control={form.control}
                name="valid_from"
                render={({ field }) => (
                    <FormItem variant="dialog">
                        <FormLabel variant="dialog" required>
                            {formatMessage(membershipMessages.validFrom)}
                        </FormLabel>
                        <FormControlStack>
                            <FormControl>
                                <CalendarWithTime dateISO={field.value} onChange={field.onChange} />
                            </FormControl>
                            <FormMessage />
                        </FormControlStack>
                    </FormItem>
                )}
            />
            <FormField
                control={form.control}
                name="valid_to"
                render={({ field }) => (
                    <FormItem variant="dialog">
                        <FormLabel variant="dialog">{formatMessage(membershipMessages.validTo)}</FormLabel>
                        <FormControlStack>
                            <FormControl>
                                <CalendarWithTime dateISO={field.value} onChange={field.onChange} />
                            </FormControl>
                            <FormMessage />
                        </FormControlStack>
                    </FormItem>
                )}
            />
            <InputFormField<MembershipFormSchemaValues>
                form={form}
                name="max_allowed_spaces_count"
                label={formatMessage(membershipMessages.maxAllowedSpaces)}
                type="number"
            />
        </Form>
    );
}

export default MembershipForm;
